<div mat-dialog-title fxLayoutAlign="space-between center">
  <h2>{{ 'transactions.add-card' | translate }}</h2>
</div>

<mat-progress-bar mode="determinate"></mat-progress-bar>

<div class="core-clinician">
  <form
    *ngIf="cardForm"
    (ngSubmit)="saveCard()"
    [formGroup]="cardForm"
    autocomplete="off"
  >
    <mat-dialog-content>
      <div fxLayout="column" fxLayoutGap="1rem">
        <mat-form-field appearance="fill">
          <mat-label>{{ 'transactions.card-holder' | translate }}</mat-label>
          <input matInput formControlName="holderName" />
          <mat-error
            *ngIf="
              cardForm.get('holderName').invalid &&
              cardForm.get('holderName').touched
            "
            >{{ getErrorMessage('holderName', 'Name') }}</mat-error
          >
        </mat-form-field>

        <ng-container *ngIf="patient.hasAddress">
          <mat-slide-toggle
            (change)="onRadioAddressSet()"
            color="primary"
            checked
            >{{ 'transactions.use-address-file' | translate }}</mat-slide-toggle>

          <div *ngIf="useAddressOnFile">
            <address *ngIf="cardForm.value.holderAddress">
              {{ cardForm.value.holderAddress | address: true }}
            </address>
          </div>
        </ng-container>

        <div *ngIf="!useAddressOnFile || !patient.hasAddress">
          <mmx-address-field
            formControlName="holderAddress"
          ></mmx-address-field>
        </div>

        <mmx-payment-card-form
          [formConfiguration]="cardFormConfiguration"
          [providerConfiguration]="paymentProviderConfiguration"
          [clientName]="clinic.name">
        </mmx-payment-card-form>

      </div>
    </mat-dialog-content>

    <mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-stroked-button type="button" mat-dialog-close>
        {{ 'common.cancel' | translate }}
      </button>
      <button
        mat-flat-button
        type="submit"
        color="primary"
        [disabled]="submitDisabled"
      >
        {{ 'common.save' | translate }}
      </button>
    </mat-dialog-actions>
  </form>
</div>
